export default "__VITE_ASSET__DSTWb2hO__"